module.exports = __webpack_public_path__ + "assets/pictograms/user-profile-empty-state.5201eb2a75919283830a776325a2c9af.svg";